import React from "react";
import Badge from "@material-ui/core/Badge";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { makeJSDateObject } from "../utils/helpers";

const InlineCalendar = (props) => {
  const { date, changeDate, selectedDays } = props;

  return (
    <KeyboardDatePicker
      id="date-picker-dialog"
      label="Date"
      // format="M-D-yyyy"
      value={date}
      onChange={changeDate}
      onMonthChange={changeDate}
      onYearChange={changeDate}
      disableFuture={true}
      style={{ width: "100%" }}
      renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
        const date = makeJSDateObject(day);
        const isSelected =
          isInCurrentMonth && selectedDays.includes(date.getDate());
        return !isSelected ? (
          dayComponent
        ) : (
          <Badge color="secondary" overlap="circular" variant="dot">
            {dayComponent}
          </Badge>
        );
      }}
      KeyboardButtonProps={{
        "aria-label": "change date",
      }}
    />
  );
};

export default InlineCalendar;
